@defer (when data()) {
  <div
    class="flex flex-row gap-8 items-center profile-header profile-title-row org-header page-header-sticky pt-4 pb-10"
    data-testid="profile-title-row"
  >
    <span class="profile-title" data-testid="profile-title">
      @let userName =
        {
          firstName: data().personalDetails.firstName,
          lastName: data().personalDetails.lastName,
        };
      {{ userName | fullName }}
    </span>

    @if (data().personalDetails.isPi) {
      <span class="profile-role-chip" data-testid="profile-role-chip">
        Principal Investigator
      </span>
    }
    @if ($canImpersonate()) {
      <span
        class="relative top-[5px] cursor-pointer"
        data-testid="profile-header__action-menu"
      >
        <mat-icon
          class="more_options"
          [matMenuTriggerFor]="profileMenu"
          data-testid="profile-header__kebab-menu"
        >
          more_horiz
        </mat-icon>
        <mat-menu #profileMenu="matMenu">
          <button
            mat-menu-item
            (click)="impersonateProfile()"
            data-testid="profile-header__impersonate-profile-button"
          >
            <mat-icon fontSet="material-symbols-outlined">badge</mat-icon>
            Impersonate
          </button>
        </mat-menu>
      </span>
    }
  </div>
}
